import { Injectable } from '@angular/core';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { retry, RetryConfig } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class WebsocketKioskService {
  private socket$!: WebSocketSubject<any>;
  private conectionStatus: String = ''
  private url = "http://localhost:8765";
  private retryCfg : RetryConfig = {
    delay: 5000,
  }

  constructor() { 
    this.createConnection()
    this.checkConection()
  }

  createConnection() {
      this.socket$ = webSocket({
            url: this.url });
    }
  
    checkConection() {
      setInterval(() => {
            this.sendMessage('ping')
      },15000);
     /*     this.socket$.pipe().subscribe(
            message => this.conectionStatus = 'Conexão estabelecida, aguardando eventos!',
            error =>  this.conectionStatus = 'Conexão perdida!...Tentando reconectar',
            () => this.conectionStatus = 'Conexão perdida!...Renicie a pagina'
      );
      return this.conectionStatus*/
    }
  
    reciveMessage(){
      return this.socket$.pipe(retry(this.retryCfg))
    }
  
    sendMessage(message: any) {
      this.socket$.next(message);
    }
  
    closeConnection() {
      this.socket$.complete();
    }
}
